<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <p @click="$router.go(-1)" class="back">back</p>
      <md-card>
        <md-card-content v-if="store" class="md-layout md-gutter">
          <div class="md-layout-item md-size-100">
            <md-field>
              <label>Name</label>
              <md-input v-model="store.name" type="text"></md-input>
              <span class="md-helper-text">Required</span>
            </md-field>
          </div>
          <div class="md-layout-item md-size-100">
            <md-field>
              <label>Description</label>
              <md-textarea
                v-model="store.description"
                type="text"
              ></md-textarea>
            </md-field>
          </div>
        </md-card-content>
        <md-card-actions md-alignment="space-between">
          <md-button class="md-primary md-round md-small" @click="validate()"
            >Save</md-button
          >
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>

<script>
import { db } from "@/config/firebaseInit";
import Swal from "sweetalert2";
import Upload from "@/components/Upload.vue";

export default {
  components: {
    upload: Upload
  },
  data() {
    return {
      batch: db.batch(),
      store: {
        name: "",
        description: ""
      },
      stores: []
    };
  },
  firestore: {
    stores: db.collection("store")
  },
  created() {
    let storeId = this.$route.params.store_id;
    let storeTemplate = Object.assign({}, this.store);

    return this.$bind("store", db.collection("store").doc(storeId)).then(() => {
      if (!this.store) {
        this.store = storeTemplate;
      }
    });
  },
  methods: {
    validate() {
      let valid = true;
      for (let k in this.contractor) {
        if (!this.contractor[k] && k != "description") {
          valid = false;
          console.log(k);
        }
      }

      if (valid) {
        this.save();
      } else {
        return Swal.fire("Missing Fields", "Please enter all required fields");
      }
    },
    async save() {
      console.log(this.$route.params.store_id);
      return db
        .collection("store")
        .doc(this.$route.params.store_id)
        .set(this.store, { merge: true })
        .then(() => {
          return Swal.fire("Success", "Page Updated", "success");
        });
    }
  }
};
</script>

<style lang="css" scoped>
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}
</style>
